import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import './component/preloader/preloader.css'; 
import App from './App';

import './index.css';


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <App />
);

